// @ts-nocheck <-- this gets rid of all of the 'issues' compiling
// the comparator fields as strings and then converting
// them to functions at runtime.
import { ColDef } from 'ag-grid-community';
import {
  entityTypeGetter,
  footprintStatusGetter,
  offeringContentSourceGetter,
  offeringTypeGetter,
  seriesTitleGetter,
  seasonTitleGetter,
  titleGetter,
  partnerGetter,
  milestoneStatusGetter,
  startDateFormatter,
  endDateFormatter,
  milestoneDateGetter,
  milestoneCodeGetter,
  playlistEntriesGetter,
  adMarkerGetter,
  createdDateGetter,
  updatedDateGetter,
  globalReleaseDateGetter,
  marketGetter,
  latestCommentGetter,
  primaryBrandLabels,
  secondaryBrandLabels,
  milestoneDetailGetter,
  complianceGetter,
  hdrFrameSizeGetter,
  sdrFrameSizeGetter,
  hdrPictureAspectRatioGetter,
  sdrPictureAspectRatioGetter,
  hdrScanningFormatGetter,
  sdrScanningFormatGetter,
  ratingsGetter,
  fetchMVPLanguages
} from './offeringValueGetters';

import { comparator, dateComparator } from '../comparators';
import {
  fulfilledAudioComponentsGetter,
  fulfilledTimedTextComponentsGetter,
  fulfilledMarkersGetter,
  fulfilledAnnotationslabelsGetter,
  fulfilledMediaDurationGetter,
  dynamicRangeIndicatorGetter
} from '../columnsHelpers/fulfilledComponentsGetters';
import { taskCIDGetter } from '../columnsHelpers/globalValueGetters';
import {
  activePresManifAudioComponentsGetter,
  activePresManifTimedTextComponentsGetter,
  activePresManifMarkersGetter,
  activePresManifAnnotationslabelsGetter,
  activePresManifMediaDurationGetter,
  activePresManifDynamicRangeIndicatorGetter
} from '../columnsHelpers/activePresManifCompGetters';

export function SetOfferingValueGetters(columnDefs: ColDef[]) {
  columnDefs.forEach((cd) => {
    let keys = Object.keys(cd);
    if (keys.includes('valueGetter')) {
      if (typeof cd.valueGetter === 'string') {
        switch (cd.valueGetter) {
          case 'entityTypeGetter':
            cd.valueGetter = entityTypeGetter;
            break;
          case 'footprintStatusGetter':
            cd.valueGetter = footprintStatusGetter;
            break;
          case 'offeringContentSourceGetter':
            cd.valueGetter = offeringContentSourceGetter;
            break;
          case 'offeringTypeGetter':
            cd.valueGetter = offeringTypeGetter;
            break;
          case 'seriesTitleGetter':
            cd.valueGetter = seriesTitleGetter;
            break;
          case 'seasonTitleGetter':
            cd.valueGetter = seasonTitleGetter;
            break;
          case 'titleGetter':
            cd.valueGetter = titleGetter;
            break;
          case 'partnerGetter':
            cd.valueGetter = partnerGetter;
            break;
          case 'marketGetter':
            cd.valueGetter = marketGetter;
            break;
          case 'startDateFormatter':
            cd.valueGetter = startDateFormatter;
            break;
          case 'endDateFormatter':
            cd.valueGetter = endDateFormatter;
            break;
          case 'createdDateGetter':
            cd.valueGetter = createdDateGetter;
            break;
          case 'updatedDateGetter':
            cd.valueGetter = updatedDateGetter;
            break;
          case 'playlistEntriesGetter':
            cd.valueGetter = playlistEntriesGetter;
            break;
          case 'milestoneStatusGetter':
            cd.valueGetter = milestoneStatusGetter;
            // let ap = cd.cellRendererParams.activity ? 'Activity' : 'Process';
            // let f = cd.headerName!.split(' ').join('|');
            // cd.valueGetter = function (params) {
            //   return milestoneStatusGetter(params);
            // };
            break;
          case 'milestoneDateGetter':
            cd.valueGetter = milestoneDateGetter;
            break;
          case 'milestoneCodeGetter':
            cd.valueGetter = milestoneCodeGetter;
            break;
          case 'adMarkerGetter':
            cd.valueGetter = adMarkerGetter;
            break;
          case 'globalReleaseDateGetter':
            cd.valueGetter = globalReleaseDateGetter;
            break;
          case 'primaryBrandLabels':
            cd.valueGetter = primaryBrandLabels;
            break;
          case 'secondaryBrandLabels':
            cd.valueGetter = secondaryBrandLabels;
            break;
          case 'latestCommentGetter':
            cd.valueGetter = latestCommentGetter;
            break;
          case 'milestoneDetailGetter':
            cd.valueGetter = milestoneDetailGetter;
            break;
          case 'fulfilledAudioComponentsGetter':
            cd.valueGetter = fulfilledAudioComponentsGetter;
            break;
          case 'fulfilledTimedTextComponentsGetter':
            cd.valueGetter = fulfilledTimedTextComponentsGetter;
            break;
          case 'fulfilledMarkersGetter':
            cd.valueGetter = fulfilledMarkersGetter;
            break;
          case 'fulfilledAnnotationslabelsGetter':
            cd.valueGetter = fulfilledAnnotationslabelsGetter;
            break;
          case 'fulfilledMediaDurationGetter':
            cd.valueGetter = fulfilledMediaDurationGetter;
            break;
          case 'dynamicRangeIndicatorGetter':
            cd.valueGetter = dynamicRangeIndicatorGetter;
            break;
          case 'complianceGetter':
            cd.valueGetter = complianceGetter;
            break;
          case 'hdrFrameSizeGetter':
            cd.valueGetter = hdrFrameSizeGetter;
            break;
          case 'sdrFrameSizeGetter':
            cd.valueGetter = sdrFrameSizeGetter;
            break;
          case 'hdrPictureAspectRatioGetter':
            cd.valueGetter = hdrPictureAspectRatioGetter;
            break;
          case 'sdrPictureAspectRatioGetter':
            cd.valueGetter = sdrPictureAspectRatioGetter;
            break;
          case 'hdrScanningFormatGetter':
            cd.valueGetter = hdrScanningFormatGetter;
            break;
          case 'sdrScanningFormatGetter':
            cd.valueGetter = sdrScanningFormatGetter;
            break;
          case 'taskCIDGetter':
            cd.valueGetter = (params) =>
              taskCIDGetter(params?.data?.tasks, 'mezzcreation');
            break;
          case 'ratingsGetter':
            cd.valueGetter = ratingsGetter;
            break;
          case 'activePresManifAudioComponentsGetter':
            cd.valueGetter = activePresManifAudioComponentsGetter;
            break;
          case 'activePresManifTimedTextComponentsGetter':
            cd.valueGetter = activePresManifTimedTextComponentsGetter;
            break;
          case 'activePresManifMarkersGetter':
            cd.valueGetter = activePresManifMarkersGetter;
            break;
          case 'activePresManifAnnotationslabelsGetter':
            cd.valueGetter = activePresManifAnnotationslabelsGetter;
            break;
          case 'activePresManifMediaDurationGetter':
            cd.valueGetter = activePresManifMediaDurationGetter;
            break;
          case 'activePresManifDynamicRangeIndicatorGetter':
            cd.valueGetter = activePresManifDynamicRangeIndicatorGetter;
          case 'fetchMVPLanguages':
            cd.valueGetter = fetchMVPLanguages;
            break;
          default:
            break;
        }
      }
    }
    if (keys.includes('comparator')) {
      if (typeof cd.comparator === 'string') {
        switch (cd.comparator) {
          case 'comparator':
            cd.comparator = comparator;
          case 'dateComparator':
            cd.comparator = dateComparator;
        }
      }
    }
  });
}
